import * as React from 'react';
/**
 *
 * Original name: follow
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=6364%3A6
 *
 */
export const FollowPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M11.04 47A5.342 5.342 0 0 1 17 41.04 5.34 5.34 0 0 1 22.96 47 5.34 5.34 0 0 1 17 52.96 5.34 5.34 0 0 1 11.04 47Z", fill: "currentColor" }),
    React.createElement("path", { d: "M33.788 53c.49-1.871.712-3.89.712-6 0-5.11-1.3-9.675-4.562-12.938C26.675 30.8 22.11 29.5 17 29.5c-2.11 0-4.128.222-6 .712v4.176c1.71-.591 3.711-.888 6-.888 8.958 0 13.5 4.542 13.5 13.5 0 2.29-.296 4.29-.887 6h4.175Z", fill: "currentColor" }),
    React.createElement("path", { d: "M46.129 53a46.31 46.31 0 0 0 .371-6c0-9.091-2.309-16.656-7.576-21.924C33.656 19.81 26.09 17.5 17 17.5a46.19 46.19 0 0 0-6 .372v4.036c1.867-.272 3.867-.408 6-.408 16.92 0 25.5 8.58 25.5 25.5 0 2.133-.136 4.133-.408 6h4.037Z", fill: "currentColor" })));
